import { React, useEffect, useState } from "react";
import AppButton from "./AppButton.component";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  Button,
  Box,
  Divider,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import {
  SEND_EMAIL,
  CREATE_CUSTOMER,
  SEND_TEXT,
} from "../../graphql/mutation/mutation.js";

import { InputValidation } from "../../utils/InputValidationRegex";
import { useAuth } from "../../context/Auth.context";
import {
  appUrl,
  capitalizeFirstLetter,
  delay,
  firstOfMonth,
  formatToDate,
  formatToDateOnly,
  today,
} from "../../utils/Utils";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/App.context";
import {
  FETCH_CUSTOMERS,
  FETCH_DEALERSHIP_DETAILS,
} from "../../graphql/query/query";
import HocPopup from "../../hoc/hocPopup.js";
import { useVerification } from "../../context/Verification.context.jsx";
import { use } from "react";
import Theme from "../../utils/Theme.jsx";
// import { DecryptData, EncryptData } from "../../utils/dataEncryptDecrypt.jsx";

// import CryptoJS from "crypto-js";
const INITIAL_CUSTOMER_STATE = {
  firstName: "",
  lastName: "",
  email: "",
  mobileNumber: "",
  userId: "",
};

const GetUserDetails = ({
  onClose,
  isURL = false,
  dialog,
  OmniUser = false,
}) => {
  const theme = useTheme();
  const auth = useAuth();
  const params = useParams();
  const app = useAppContext();
  const navigate = useNavigate();
  const verification = useVerification();

  const [saveCustomer, setSaveCustomer] = useState({
    email: false,
    continue: false,
    text: false,
  });
  const [customer, setCustomer] = useState(INITIAL_CUSTOMER_STATE);
  const [isCustomer, setIsCustomer] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isQueryRun, setIsQueryRun] = useState(false);
  const [customerText, setCustomerText] = useState("");

  const { data: FetchDealershipDetails, loading: dealershipLoding } = useQuery(
    FETCH_DEALERSHIP_DETAILS,
    {
      variables: {
        dealershipId: params.dealershipId || auth.user.dealership_id,
      },
    }
  );

  const isWalkthrough =
    FetchDealershipDetails?.fetchDealershipDetails?.isWalthrough;

  useEffect(() => {
    const isValidMobile = !InputValidation.numberValidation(
      customer.mobileNumber
    );

    const shouldRunQuery = isValidMobile && customer.mobileNumber.length === 13;

    setIsOpen(shouldRunQuery);
  }, [customer?.mobileNumber]);

  const { data: fetchCustomers } = useQuery(FETCH_CUSTOMERS, {
    variables: {
      fetchCustomerInput: {
        mobile_number: customer.mobileNumber,
        employee_user_id:
          parseInt(params?.spid) || parseInt(auth?.user?.user_id),
        dealership_id:
          parseInt(params?.dealershipId) || parseInt(auth?.user?.dealership_id),
      },
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    skip: !isOpen,
  });

  useEffect(() => {
    if (isURL) {
      setCustomerText("We've seen this phone number before. is this you?");
    }
    if (
      fetchCustomers?.fetchCustomerDetails?.employee_user_id &&
      auth?.user?.user_id
    ) {
      if (
        fetchCustomers?.fetchCustomerDetails?.employee_user_id !==
        auth?.user?.user_id
      ) {
        const data = fetchCustomers?.fetchCustomerDetails;

        setCustomerText(
          `Previous record under ${data?.employee_name} from ${formatToDateOnly(
            data?.created_at
          )} exists. Do you want to add to that record or begin new record under ${capitalizeFirstLetter(
            auth?.user?.first_name
          )} ${auth?.user?.last_name}`
        );
      } else {
        setCustomerText("We've seen this phone number before. is this you?");
      }
    }
  }, [fetchCustomers]);

  useEffect(() => {
    if (customer.userId && isQueryRun) {
      if (saveCustomer.email) {
        emailHandler(customer.userId);
      } else if (saveCustomer.text) {
        textHandler(customer.userId);
      } else if (saveCustomer.continue) {
        continueHandler(isURL);
      }
    }
  }, [customer.userId, isQueryRun]);

  useEffect(() => {
    app.setFetchData({
      d_startDate: firstOfMonth,
      d_endDate: today,
      f_startDate: firstOfMonth,
      f_endDate: today,
      pageCount: 0,
      rowsPerPage: 25,
      searchEmployee: "",
      searchCustomer: "",
    });
  }, []);

  const [createCustomer, { loading: customerLoading }] = useMutation(
    CREATE_CUSTOMER,
    {
      onCompleted: async (data) => {
        if (data?.createCustomer?.user_id) {
          const userId = data?.createCustomer?.user_id;
          setCustomer({
            ...customer,
            userId: userId,
          });
          setIsQueryRun(true);
          if (OmniUser) {
            verification.setCustomer({
              ...customer,
              userId: data.createCustomer.user_id,
              isWalkthrough: isWalkthrough,
              isOmniUser: OmniUser,
            });
            navigate("/express/service");
          }
          // if (userId) {
          //   console.log("insideUseEffect", saveCustomer);
          //   if (saveCustomer.email) {
          //     console.log("insideUseEffect111", saveCustomer);
          //     emailHandler(userId);
          //   } else if (saveCustomer.text) {
          //     textHandler(userId);
          //   } else if (saveCustomer.continue) {
          //     continueHandler(isURL);
          //   }
          // }
        } else {
          console.log("customer not saved");
        }
      },
    }
  );

  const [sendEmail, { loading, data }] = useMutation(SEND_EMAIL, {
    onCompleted: async (data) => {
      if (data) {
        setCustomer(INITIAL_CUSTOMER_STATE);
        await delay(1000);
      }
    },
  });

  const [sendText, { loading: textLoading, data: textData }] = useMutation(
    SEND_TEXT,
    {
      onCompleted: async (data) => {
        if (data) {
          setCustomer(INITIAL_CUSTOMER_STATE);
          await delay(1000);
        }
      },
    }
  );

  const emailHandler = async (userId) => {
    if (
      !InputValidation.emailValidation(customer.email) &&
      customer.email !== ""
    ) {
      sendEmail({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            // ?via= tells Consent which channel the customer was sent through,
            // so it can be logged when the Knowledge Hub starts.
            url:
              appUrl +
              `/verification/consent/${auth.user.user_id}/${
                auth.user.dealership_id || params.dealershipId
              }/${customer.userId}/${isWalkthrough}/0/false?via=email`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: false,
          },
        },
      });
    }
  };

  const textHandler = async (userId) => {
    if (
      !InputValidation.numberValidation(customer.mobileNumber) &&
      customer.mobileNumber !== ""
    ) {
      sendText({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${auth.user.user_id}/${
                auth.user.dealership_id || params.dealershipId
              }/${customer.userId}/${isWalkthrough}/0/false?via=text`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: false,
          },
        },
      });
    }
  };

  const saveCustomerHandler = async () => {
    let verificationUrl = {
      firstName: customer.firstName,
      lastName: customer.lastName,
      email: customer.email,
      mobileNumber: customer.mobileNumber,
    };

    await createCustomer({
      variables: {
        customerInput: {
          user_id: parseInt(customer?.userId),
          first_name: customer.firstName,
          last_name: customer.lastName,
          email: customer.email,
          mobile_number: customer.mobileNumber,
          employee_user_id: parseInt(params?.spid) || auth?.user?.user_id,
          dealership_id:
            parseInt(params?.dealershipId) || auth?.user?.dealership_id,
          d_startDate: app.fetchData.d_startDate || firstOfMonth,
          d_endDate: app.fetchData.d_endDate || today,
          f_startDate: app.fetchData.f_startDate || firstOfMonth,
          f_endDate: app.fetchData.f_endDate || today,
          pageCount: app.fetchData.pageCount || 0,
          rowsPerPage: app.fetchData.rowsPerPage || 25,
          search_employee: app.fetchData.searchEmployee || "",
          search_customer: app.fetchData.searchCustomer || "",
          isEmployeeOnly: false,
          timezone: new Date().getTimezoneOffset(),
          verification_url: JSON.stringify(verificationUrl),
          isAdmin: false,
        },
      },
    });
  };

  const continueHandler = async (isURL) => {
    if (!OmniUser) {
      if (isURL) {
        navigate(
          `/verification/consent/${params.spid || auth?.user?.user_id}/${
            params.dealershipId || auth?.user?.dealership_id
          }/${customer.userId}/${isWalkthrough}/0/false?via=device`
        );
      } else {
        onClose();
        await delay(250);
        window.open(
          `/verification/consent/${auth?.user?.user_id || params.spid}/${
            auth?.user?.dealership_id || params.dealershipId
          }/${customer.userId}/${isWalkthrough}/0/false?via=device`,
          "_blank"
        );
      }
    }
  };

  return (
    <>
      {/* <Divider /> */}
      <Box
        sx={{
          m: window.innerWidth <= 750 ? "5px" : "8px 10px 0px 15px",
        }}
      >
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "5px" }}>
          <InputLabel
            color={
              InputValidation.numberValidation(customer.mobileNumber)
                ? "error"
                : "primary"
            }
          >
            Mobile Number *
          </InputLabel>
          <OutlinedInput
            required={true}
            label="Mobile Number"
            value={InputValidation.phoneNumberFormat(customer.mobileNumber)}
            onChange={(event) => {
              setCustomer({
                ...customer,
                mobileNumber: event.target.value,
              });
            }}
            sx={{ borderRadius: "6px" }}
            error={InputValidation.numberValidation(customer.mobileNumber)}
          />

          <FormHelperText sx={{ color: theme.palette.error.main }}>
            {InputValidation.numberValidation(customer.mobileNumber)
              ? "Please enter a valid mobile number"
              : " "}
          </FormHelperText>
        </FormControl>

        {isOpen &&
          fetchCustomers?.fetchCustomerDetails?.first_name &&
          customerText && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                bgcolor: "#FFF7F7",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "15px",
                p: 1,
              }}
            >
              <Typography>
                {customerText} <br />{" "}
              </Typography>
              <Typography sx={{ color: Theme.palette.primary.main }}>
                {fetchCustomers?.fetchCustomerDetails?.first_name?.toUpperCase()}{" "}
                {fetchCustomers?.fetchCustomerDetails?.last_name?.toUpperCase()}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 1,
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AppButton
                  buttonText={"Yes"}
                  variant={isCustomer === "yes" ? "contained" : "outlined"}
                  sx={{ width: "20%" }}
                  clickHandler={() => {
                    setIsCustomer("yes");
                    let datas = fetchCustomers?.fetchCustomerDetails;
                    setCustomer((prev) => ({
                      ...prev,
                      firstName: datas?.first_name,
                      lastName: datas?.last_name,
                      mobileNumber: datas?.mobile_number,
                      email: datas?.email,
                      userId: datas?.userId,
                    }));
                    setIsOpen(false);
                  }}
                />
                <AppButton
                  buttonText={"No"}
                  sx={{ width: "20%" }}
                  variant={isCustomer === "no" ? "contained" : "outlined"}
                  clickHandler={() => {
                    setIsCustomer("no");
                    setCustomer((prev) => ({
                      ...prev,
                      firstName: "",
                      lastName: "",
                      email: "",
                      userId: "",
                    }));
                    setIsOpen(false);
                  }}
                />
              </Box>
            </Box>
          )}

        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "5px" }}>
          <InputLabel
            color={
              InputValidation.emailValidation(customer.email)
                ? "error"
                : "primary"
            }
          >
            Email *
          </InputLabel>
          <OutlinedInput
            required
            label="Email"
            value={customer.email}
            onChange={(event) => {
              setCustomer({
                ...customer,
                email: event.target.value,
              });
            }}
            sx={{ borderRadius: "6px" }}
            error={InputValidation.emailValidation(customer.email)}
          />
          <FormHelperText sx={{ color: theme.palette.error.main }}>
            {InputValidation.emailValidation(customer.email)
              ? "Please enter a valid email"
              : " "}
          </FormHelperText>
        </FormControl>

        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "5px" }}>
          <InputLabel
            color={
              InputValidation.nameValidation(customer.firstName)
                ? "error"
                : "primary"
            }
          >
            First Name *
          </InputLabel>
          <OutlinedInput
            required
            label="First Name"
            value={customer.firstName}
            onChange={(event) => {
              setCustomer({
                ...customer,
                firstName: event.target.value,
              });
            }}
            sx={{ borderRadius: "6px" }}
            error={InputValidation.nameValidation(customer.firstName)}
          />
          <FormHelperText sx={{ color: theme.palette.error.main }}>
            {InputValidation.nameValidation(customer.firstName)
              ? "Please enter a valid name"
              : " "}
          </FormHelperText>
        </FormControl>

        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "5px" }}>
          <InputLabel
            color={
              InputValidation.nameValidation(customer.lastName)
                ? "error"
                : "primary"
            }
          >
            Last Name *
          </InputLabel>
          <OutlinedInput
            required
            label="Last Name"
            value={customer.lastName}
            onChange={(event) => {
              setCustomer({
                ...customer,
                lastName: event.target.value,
              });
            }}
            sx={{ borderRadius: "6px" }}
            error={InputValidation.nameValidation(customer.lastName)}
          />
          <FormHelperText sx={{ color: theme.palette.error.main }}>
            {InputValidation.nameValidation(customer.lastName)
              ? "Please enter a valid name"
              : " "}
          </FormHelperText>
        </FormControl>
      </Box>

      <>
        <>
          {customerLoading ? (
            <CircularProgress
              size={30}
              sx={{
                marginBottom: "24px",
                alignSelf: "center",
              }}
            />
          ) : (
            <Button
              variant="text"
              onClick={() => {
                setSaveCustomer({ ...saveCustomer, continue: true });
                saveCustomerHandler();
                // if (OmniUser) {
                //   navigate("/services/service");
                // }
              }}
              sx={{ m: "7px" }}
              disabled={
                customer.firstName === "" ||
                customer.lastName === "" ||
                customer?.email === "" ||
                customer?.mobileNumber == "" ||
                InputValidation.nameValidation(customer.firstName) ||
                InputValidation.nameValidation(customer.lastName) ||
                InputValidation.emailValidation(customer.email) ||
                InputValidation.numberValidation(customer.mobileNumber) ||
                dealershipLoding
              }
            >
              {OmniUser ? "NEXT" : "CONTINUE HERE"}
            </Button>
          )}
        </>
        <>
          {!isURL ? (
            <>
              <Divider sx={{ mb: "5px" }} />
              <Box
                sx={{
                  mx: "16px",
                  display: "flex",
                  flexDirection: "row",
                  // marginTop: "5px",
                  gap: "8px",
                }}
              >
                {textData?.sendTextRequest.user_id ? (
                  <Box
                    sx={{
                      display: "flex",
                      my: "14px",
                      width: "49%",
                      justifyContent: "center",
                    }}
                  >
                    <CheckCircle color={"primary"} />
                    <span
                      style={{
                        color: theme.palette.primary.main,
                        marginLeft: "4px",
                      }}
                    >
                      TEXT SENT
                    </span>
                  </Box>
                ) : (
                  <AppButton
                    buttonText="Send Text"
                    loading={textLoading}
                    clickHandler={() => {
                      setSaveCustomer({ ...saveCustomer, text: true });
                      saveCustomerHandler();
                    }}
                    size="medium"
                    variant="outlined"
                    sx={{ width: "49%" }}
                    disabled={
                      customer.firstName === "" ||
                      customer.lastName === "" ||
                      customer?.email === "" ||
                      customer?.mobileNumber == "" ||
                      InputValidation.nameValidation(customer.firstName) ||
                      InputValidation.nameValidation(customer.lastName) ||
                      InputValidation.emailValidation(customer.email) ||
                      InputValidation.numberValidation(customer.mobileNumber) ||
                      customerLoading ||
                      dealershipLoding
                    }
                  />
                )}
                {data?.sendEmailRequest.user_id ? (
                  <Box
                    sx={{
                      display: "flex",
                      my: "14px",
                      width: "49%",
                      justifyContent: "center",
                    }}
                  >
                    <CheckCircle color={"primary"} />
                    <span
                      style={{
                        color: theme.palette.primary.main,
                        marginLeft: "4px",
                      }}
                    >
                      EMAIL SENT
                    </span>
                  </Box>
                ) : (
                  <AppButton
                    buttonText="Send Email"
                    loading={loading}
                    clickHandler={() => {
                      setSaveCustomer({ ...saveCustomer, email: true });
                      saveCustomerHandler();
                    }}
                    size="medium"
                    variant="contained"
                    sx={{ width: "49%" }}
                    disabled={
                      customer.firstName === "" ||
                      customer.lastName === "" ||
                      customer?.email === "" ||
                      customer?.mobileNumber == "" ||
                      InputValidation.nameValidation(customer.firstName) ||
                      InputValidation.nameValidation(customer.lastName) ||
                      InputValidation.emailValidation(customer.email) ||
                      InputValidation.numberValidation(customer.mobileNumber) ||
                      customerLoading ||
                      dealershipLoding
                    }
                  />
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  p: "14px",
                }}
              >
                <Typography variant="body" fontSize={"12px"} color={"grey"}>
                  By selecting Send, you confirm that the customer has authorized
                  the dealership to send this communication by the selected method.
                </Typography>
              </Box>
            </>
          ) : null}
        </>
      </>

      <NotificationContainer />
    </>
  );
};

export default GetUserDetails;